'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useEffect, useState } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { getEnv } from '@/utils/env';
export function PostHogProvider(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  const [isLoaded, setIsLoaded] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const apiKey = getEnv("POSTHOG_KEY");
      if (apiKey) {
        posthog.init(apiKey, {
          api_host: "https://posthog.extern.com",
          ui_host: "https://us.posthog.com",
          person_profiles: "identified_only",
          autocapture: false,
          capture_pageview: false,
          capture_pageleave: false,
          capture_exceptions: false,
          capture_performance: false,
          capture_heatmaps: false,
          capture_dead_clicks: false,
          disable_session_recording: true,
          bootstrap: {
            featureFlags: {}
          }
        });
        posthog.onFeatureFlags(() => {
          setIsLoaded(true);
        });
      }
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!isLoaded) {
    return null;
  }
  let t3;
  if ($[2] !== children) {
    t3 = <PHProvider client={posthog}>{children}</PHProvider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}